// agentCountSaga.js
import { message } from 'antd';
import { AxiosResponse } from 'axios';
import { call, put, takeLatest } from 'redux-saga/effects';
import {
  FetchAgentCountAction,
  fetchAgentCount,
  fetchAgentCountFailure,
  fetchAgentCountSuccess,
} from 'redux/slice/agent/AgentCount.slice';
import { agentGroupEndpoints } from 'services/api/endPoints';
import { HTTPClient } from 'services/api/http-client';

function* fetchAgentCountSaga(action: FetchAgentCountAction) {
  const { columns, supervisorId } = action.payload;
  try {
    const requestBody = { columns };
    const response: AxiosResponse = yield call(
      HTTPClient.PostRequest,
      `${agentGroupEndpoints.GET_AGENT_COUNT()}`,
      requestBody
    );

    message.success('Agents count successfully');
    yield put(fetchAgentCountSuccess(response.data));
  } catch (error) {
    message.error('Failed to fetch agent count');
    yield put(fetchAgentCountFailure('Failed to fetch agent count'));
  }
}

// Watcher saga
export function* watchFetchAgentCountSagas() {
  yield takeLatest(fetchAgentCount.type, fetchAgentCountSaga);
}
